import { Service, inject } from '@piwikpro/platform';
import { HttpClient } from '@piwikpro/http-crate';
import type { Store } from 'redux';
import { setFeatureFlags } from './redux/actions';

export interface IFeatureFlags {
  sdgIntegration?: boolean
}

@Service()
export class FeatureFlags {
  constructor(
    @inject('HttpCrate.httpClient') private readonly httpClient: HttpClient,
    @inject('store') private readonly store: Store,
  ) {}

  fetchFeatureFlags = async () => {
    try {
      const response = await this.httpClient.request<{
        'feature/sdg-integration'?: boolean
      }>({
        endpoint: '/api/organization/v2/features',
        method: 'GET',
      })
        .json()
        .send();

      this.store.dispatch(setFeatureFlags({
        sdgIntegration: 'feature/sdg-integration' in response && response['feature/sdg-integration'] === true,
      }));
    } catch (err: any) {
      throw err;
    }
  }
}
